import LoadingFormNormal from "components/shared-components/LoadingFormNormal";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Label, Modal, ModalBody, ModalHeader } from "reactstrap";
import { getHistoryErrorTransfer } from "store/actions";
import { tableFormateDate } from "../utils";

const HistoryTransferModal = props => {
  const dispatch = useDispatch();
  const { isOpen, toggle, id, path } = props;
  //   const [typeSign, setTypeSign] = useState(TYPE_SIGN.HSM);
  const { data, loading } = useSelector(
    state => state.errorInvoices.historyTransferError
  );

  useEffect(() => {
    if (isOpen) {
      dispatch(getHistoryErrorTransfer(id, path));
    }
  }, [isOpen]);

  return (
    <Modal
      size="sm"
      contentClassName="confirm-modal"
      isOpen={isOpen}
      role="dialog"
      style={{ minWidth: "80%" }}
      autoFocus={true}
      centered={true}
      className="exampleModal"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>
          <Label>Lịch sử truyền nhận</Label>
        </ModalHeader>
        {loading ? (
          <ModalBody>
            <LoadingFormNormal
              countInput="0"
              countButton="2"
              formClass="row-cols-1 row-cols-md-1"
              buttonClass="justify-content-end"
              buttonColClass="col-3"
            />
          </ModalBody>
        ) : (
          <React.Fragment>
            <ModalBody>
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr className="text-info">
                      <th scope="col">STT</th>
                      <th scope="col">Thời gian</th>
                      <th scope="col">Người thực hiện</th>
                      <th scope="col">Mã loại thông điệp</th>
                      <th scope="col">Diễn giải</th>
                      {/* <th scope="col">Mã TVAN</th> */}
                      <th scope="col">Mã thông điệp</th>
                      <th scope="col">Mã thông điệp tham chiếu</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data &&
                      data.map((field, index) => {
                        return (
                          <React.Fragment key={index}>
                            <tr>
                              <td>{index + 1}</td>
                              <td>
                                {tableFormateDate(field.maker_date, true)}
                              </td>
                              <td>{field.name}</td>
                              <td title={field.mltdiep}>{field.mltdiep}</td>
                              <td>{field.action}</td>
                              {/* <td>{field.tvan_code}</td> */}
                              <td>
                                {field?.tracking?.mtdiep || field?.mtdiep}
                              </td>
                              <td>
                                {field?.tracking?.mtdtchieu || field?.mtdtchieu}
                              </td>
                            </tr>
                          </React.Fragment>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </ModalBody>
          </React.Fragment>
        )}
      </div>
    </Modal>
  );
};

HistoryTransferModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  t: PropTypes.any,
  id: PropTypes.any,
  path: PropTypes.any,
};

export default HistoryTransferModal;
